import React, { useState, useEffect, useMemo } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import Loader from "pages/Separate/Loader";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";

import NewPagination from "components/Common/Newpagination";
import {
  customGlobalFilter,
  customGlobalTimerFilter,
} from "utils/common-helpers";
import { AdminTimerColumn } from "../../../utils/columns/Version Control/AdminTimerColumn.js";
import Swal from "sweetalert2";
import { fetchNodeData } from "utils/common-fetchData.js";
import secureLocalStorage from "react-secure-storage";
import configure from "configure.js";
function TableContainer({ columns, data, devCount }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    pageCount,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      globalFilter: customGlobalTimerFilter,
      initialState: {
        sortBy: [
          {
            id: "id",
            desc: true,
          },
        ],
      },
    },

    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { pageIndex, pageSize, globalFilter } = state;

  return (
    <Row>
      <Col xl="12">
        <div className="card-body ">
          <div className="d-flex justify-content-between mb-2">
            <div className="d-flex gap-3 align-items-center">
              <div className="mb-0 text-purple fs-5  fw-bold">
                Project Timer
              </div>
              <div className="col-1 me-md-5">
                <select
                  className="border-radius form-select"
                  style={{ width: "100px" }}
                  value={pageSize}
                  onChange={(e) => setPageSize(e.target.value)}
                >
                  {[10, 25, 50, 100].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      Show {pageSize}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <div className="search-box">
                <div className="position-relative">
                  <label htmlFor="search-bar-0" className="search-label mb-0">
                    <span id="search-bar-0-label" className="sr-only">
                      Search this table
                    </span>
                    <input
                      onChange={(e) => setGlobalFilter(e.target.value)}
                      id="search-bar-0"
                      type="text"
                      className="s form-control rounded "
                      placeholder={` Search...`}
                      value={globalFilter || ""}
                    />
                  </label>
                  <i className="bx bx-search-alt search-icon"></i>
                </div>
              </div>
              <div
                className="text-purple absent-length"
                style={{ width: "35px", height: "35px" }}
              >
                {data?.length}/{devCount}
              </div>
            </div>
          </div>
          <div className="position-relative table-responsive">
            <Table className="table table-bordered mt-4" {...getTableProps()}>
              <thead className={`fixed_view_payment_table`}>
                {headerGroups.map((headerGroup, i) => (
                  <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column, index) => (
                      <th
                        key={index}
                        className={`t-col-${index + 1} ${column.className}`}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                      >
                        <div className="d-flex align-items-center">
                          <span className="flex-grow-1 text-center header-text">
                            {column.render("Header")}
                          </span>
                          {column.isShortIcon && (
                            <span
                              onClick={() =>
                                column.getSortByToggleProps().onClick()
                              }
                              className="d-flex align-items-center ms-2"
                            >
                              <i
                                title="Ascending"
                                className={`bi bi-arrow-up info-icon ${
                                  column.isSorted && !column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                }`}
                              ></i>
                              <i
                                title="Descending"
                                className={`bi bi-arrow-down info-icon ${
                                  column.isSorted && column.isSortedDesc
                                    ? "text-dark"
                                    : ""
                                }`}
                              ></i>
                            </span>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody className="fix-introducer-header" {...getTableBodyProps()}>
                {page.map((row, i) => {
                  prepareRow(row);

                  return (
                    <tr className={`row-hover`} {...row.getRowProps()} key={i}>
                      {row.cells.map((cell, index) => {
                        return (
                          <td key={index} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          <Row className="justify-content-md-end justify-content-center align-items-center">
            <NewPagination
              gotoPage={gotoPage}
              canPreviousPage={canPreviousPage}
              previousPage={previousPage}
              canNextPage={canNextPage}
              pageIndex={pageIndex}
              pageOptions={pageOptions}
              pageSize={pageSize}
              page={page}
              data={data}
              nextPage={nextPage}
            />
          </Row>
        </div>
      </Col>
    </Row>
  );
}

const AdminTimer = () => {
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const token = secureLocalStorage.getItem("auth_token");
  const [devCount, setDevCount] = useState("");
  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  // const onStop = async (timerDetails) => {
  //   try {
  //     Swal.fire({
  //       icon: "warning",
  //       text: "Are You sure Want to Stop Timer ?",
  //       showCancelButton: true,
  //       confirmButtonText: "Yes, Stop it!",
  //       cancelButtonText: "No, cancel!",
  //     }).then(async (result) => {
  //       if (result.isConfirmed) {
  //         setLoading(true);
  //         const response = await fetchNodeData(
  //           toggleLoading,
  //           `projectTimerStop/${timerDetails.id}/${timerDetails.type}`,
  //           token
  //         );
  //         if (response.status) {
  //           // setData(response.data);
  //            fetchActiveTimer()
  //         } else {
  //           setErrorMsg(response.message || "Unexpected response structure.");
  //         }
  //       }
  //     });
  //   } catch (err) {
  //     console.error("Error fetching timer data:", err);
  //     setErrorMsg("Failed to fetch project timer.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const onStop = async (timerDetails) => {
    try {
      Swal.fire({
        icon: "warning",
        text: "Are You sure Want to Stop Timer ?",
        showCancelButton: true,
        confirmButtonText: "Yes, Stop it!",
        cancelButtonText: "No, cancel!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true);
          const response = await fetchNodeData(
            toggleLoading,
            `projectTimerStop/${timerDetails.id}/${timerDetails.type}`,
            token
          );
          if (response.status) {
            // setData(response.data)
            fetchActiveTimer();

            localStorage.removeItem("task_id");
            localStorage.removeItem("timerId");
            localStorage.removeItem("start_time");

            const timer_data = JSON.parse(
              localStorage.getItem("timer_data") || "{}"
            );

            const elapsedTime =
              timer_data.savedElapsed +
              Math.floor((new Date() - new Date(timer_data.startTime)) / 1000);

            timer_data.startTime = null;
            timer_data.savedElapsed = elapsedTime;

            localStorage.setItem("timer_data", JSON.stringify(timer_data));

            window.location.reload();
          } else {
            setErrorMsg(response.message || "Unexpected response structure.");
          }
        }
      });
    } catch (err) {
      console.error("Error fetching timer data:", err);
      setErrorMsg("Failed to fetch project timer.");
    } finally {
      setLoading(false);
    }
  };

  const fetchActiveTimer = async () => {
    try {
      setLoading(true);
      const response = await fetchNodeData(
        toggleLoading,
        `projectTimer`,
        token
      );
      if (response.status) {
        setData(response.data?.results);
        setDevCount(response.data?.devCounts);
      } else {
        setErrorMsg(response.message || "Unexpected response structure.");
      }
    } catch (err) {
      console.error("Error fetching timer data:", err);
      setErrorMsg("Failed to fetch project timer.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveTimer();
  }, []);

  const column1 = useMemo(() => AdminTimerColumn(onStop), []);

  return (
    <div>
      {isLoading && <Loader />}
      {errorMsg && (
        <div className="text-center text-danger my-3 fw-bold">{errorMsg}</div>
      )}
      {!isLoading && !errorMsg && (
        <div className="position-relative">
          <Row>
            <Col lg="12">
              <Card>
                <div className="responsive-table">
                  <TableContainer
                    columns={column1}
                    data={data}
                    devCount={devCount}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default AdminTimer;
